import { render, staticRenderFns } from "./SSPasswordResetView.vue?vue&type=template&id=2bc722e8&scoped=true&"
import script from "./SSPasswordResetView.vue?vue&type=script&lang=js&"
export * from "./SSPasswordResetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc722e8",
  null
  
)

export default component.exports